var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cx-explorateur-fichier',{attrs:{"extension-array":['pdf','jpg','png','jpeg'],"titre":"Documents Divers","show-import":"","show-refresher":"","url-ressource-end-point":_vm.urlRessourceEndPoint}})}
var staticRenderFns = []

export { render, staticRenderFns }